import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { media } from "@pathwright/ui/src/components/utils/styles"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useDiscussionListContext } from "./DiscussionListContainer"

const StyledButton = styled(Button)`
  ${media.min.phone`  
    .Community__discussion & {
      position: absolute;
      top: 20px;
      right: 20px;
      /* layer above the SwitchButton */
      z-index: 1002;
    }
  `}

  .Tooltip__trigger {
    position: absolute !important;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    line-height: 0;

    .Tooltip {
      white-space: pre-wrap;
    }
  }
`

// Dumb version so we can use in other contexts
export const StartDiscussionButton = withTranslate(
  ({ inverted, label, tooltip, onStartDiscussion, t, ...buttonProps }) => {
    if (!onStartDiscussion) return null

    return (
      <StyledButton
        styleType="secondary"
        onClick={onStartDiscussion}
        inverted={inverted}
        {...buttonProps}
        style={{ margin: "0 auto", display: "block" }}
      >
        <Pathicon icon="chat-bubble-plus" />
        <span> </span>
        {label || t("New")}
        {!!tooltip && (
          <Tooltip title={tooltip} placement="left">
            <Pathicon icon="info-circle" />
          </Tooltip>
        )}
      </StyledButton>
    )
  }
)

StartDiscussionButton.displayName = "StartDiscussionButton"

const DiscussionListStartDiscussion = ({ label, inverted, ...buttonProps }) => {
  const { context, filter, sort, onStartDiscussion } =
    useDiscussionListContext()

  if (!onStartDiscussion) return null

  return (
    <StartDiscussionButton
      onStartDiscussion={onStartDiscussion}
      inverted={inverted}
      label={label}
      {...buttonProps}
      style={{ margin: "0 auto", display: "block" }}
    />
  )
}

DiscussionListStartDiscussion.displayName = "DiscussionListStartDiscussion"

DiscussionListStartDiscussion.propTypes = {
  label: PropTypes.string
}

export default DiscussionListStartDiscussion
